import DashboardClientContent from "page_components/client/dashboard/Content";
import DashboardProvider from "context/client/dashboard";

const Dashboard = () => (
  <DashboardProvider>
    <DashboardClientContent />
  </DashboardProvider>
);

export default Dashboard;
